import React from "react";
import "../styles/print.stye.css";
import { Checkbox, FormControlLabel } from "@mui/material";

const CommentPrint = ({
  title,
  isCheckBoxApprove,
  sxTitle,
  amountLine,
  isParagraph,
  data,
  lengthDot,
}: {
  title: string;
  isCheckBoxApprove: boolean;
  sxTitle: string;
  amountLine: number;
  isParagraph: boolean;
  data: {
    isApprove: boolean | null;
    comment: string;
  };
  lengthDot: number;
}) => {
  const generateEllipsisLine = (minLength: number) => {
    return ".".repeat(minLength);
  };

  return (
    <>
      <div className={`w-full ${sxTitle} flex items-center space-content `}>
        <span className="">{title}</span>
      </div>
      {/*  */}
      <div className="w-full flex justify-start items-center">
        {isCheckBoxApprove ? (
          <>
            <FormControlLabel
              control={<Checkbox />}
              label="อนุญาต"
              checked={data.isApprove === true}
            />
            <FormControlLabel
              control={<Checkbox />}
              label="ไม่อนุญาต"
              checked={data.isApprove === false}
            />
          </>
        ) : null}
      </div>
      {/*  */}
      {Array.from({ length: amountLine }).map((_, index) => (
        <div
          key={index}
          className="flex justify-start items-center space-content"
        >
          <span
            className={`ellipsis-container ${
              index === 0 && isParagraph ? "ml-12" : ""
            }`}
          >
            <span className="ellipsis-data">
              {index === 0 ? data.comment : ""}
            </span>
            {/* size */}
            {index === 0 ? (
              <span className="ellipsis-dots">
                {generateEllipsisLine(lengthDot - (isParagraph ? 20 : 0))}
              </span>
            ) : (
              <span className="ellipsis-dots">
                {generateEllipsisLine(lengthDot)}
              </span>
            )}
          </span>
        </div>
      ))}
    </>
  );
};

export default CommentPrint;
